export const capitalize = string => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const timeStampToString = timestamp => {
  const date = timestamp.toDate();
  const month = date.getMonth() + 1;
  return (
    month +
    "/" +
    date.getDate() +
    "/" +
    date
      .getFullYear()
      .toString()
      .slice(2)
  );
};

export const timeStampToLongString = timestamp => {
  if (!timestamp) return "";
  const date = timestamp.toDate();
  const hours = date.getHours();
  let minutes = date.getMinutes();
  if (minutes < 10) minutes = "0" + minutes;
  return (
    timeStampToString(timestamp) + " " +
    (hours <= 12 ? hours : hours - 12) +
    ":" +
    minutes +
    (hours < 12 ? " AM" : " PM")
  );
};

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export const formatSecondsToHMMSS = function (sec_num) {
  sec_num = Math.round(sec_num);
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);

  hours = hours > 0 ? `${hours}:` : ''; // remove hours if not high enough to show
  minutes = minutes < 10 ? `0${minutes}:` : `${minutes}:`;
  seconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  return hours + minutes + seconds;
}

export const stringList = function (array) {
  let str = "";
  for (let i = 0; i < array.length; i++) {
    str += array[i];
    if (i !== array.length - 1) {
      str += ", ";
    }
  }
  return str;
}